import { Box, Typography, Container } from "@mui/material";
export type NewYearHolidayNoticeProps = {
  holidayStartDateText: string;
  holidayEndDateText: string;
  businessStartDateText: string;
};

export const NewYearHolidayNotice: React.FC<NewYearHolidayNoticeProps> = ({
  holidayStartDateText,
  holidayEndDateText,
  businessStartDateText,
}) => (
  <Container
    maxWidth="lg"
    sx={{
      py: 3,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }}
  >
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: 5,
      }}
    >
      <Typography component="h1" variant="h5">
        年末年始のお知らせ
      </Typography>
      <Typography
        variant="body2"
        color="textPrimary"
        align="center"
        sx={{ marginTop: 2 }}
      >
        平素より格別のご愛顧を賜り、誠にありがとうございます。さて、弊社では下記の期間を年末年始休業とさせていただきます。
      </Typography>
      <Typography
        variant="body2"
        color="textPrimary"
        align="center"
        sx={{ marginTop: 2 }}
      >
        休業期間：{holidayStartDateText} ～ {holidayEndDateText}
      </Typography>
      <Typography
        variant="body2"
        color="textPrimary"
        align="center"
        sx={{ marginTop: 2 }}
      >
        休業期間中にいただきましたお問い合わせやご発注につきましては、
        {businessStartDateText}より順次対応させていただきます。
      </Typography>
      <Typography
        variant="body2"
        color="textPrimary"
        align="center"
        sx={{ marginTop: 2 }}
      >
        お客様にはご不便をおかけいたしますが、何卒ご理解賜りますようお願い申し上げます。来年も変わらぬご愛顧を賜りますようお願い申し上げます。
      </Typography>
    </Box>
  </Container>
);
